import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as ArrowDown } from "../../assets/icon/boxdown.svg";
import { ReactComponent as ArrowUp } from "../../assets/icon/boxup.svg";
import { String } from "../../constants/Strings";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";
const EstimatorCard = ({ lifeCoverage, termLifeInsurance, percentage }) => {
  return (
    <Box sx={{ mt: "20px", p: 1 }}>
      <Typography
        sx={{
          color: getColor.PrimaryWoodSmoke,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
          ml: "10px",
        }}
      >
        {String.Dashboard.mainDashboard.InsuranceEstimator}
      </Typography>
      <Card
        sx={{
          boxShadow: "0px 4px 12px rgba(80, 86, 98, 0.15)",
          borderRadius: 7,
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: getColor.red,
                fontWeight: "bold",
                fontSize: "24px",
              }}
            >
              {percentage > 0 ? (
                <ArrowUp
                  style={{
                    width: "40px",
                    height: "40px",
                  }}
                />
              ) : (
                <ArrowDown
                  style={{
                    width: "40px",
                    height: "40px",
                  }}
                />
              )}
              <Typography
                component={"span"}
                sx={{
                  color: percentage > 0 ? getColor.sucess : getColor.red,
                  fontSize: 15,
                  fontFamily: fonts.inter,
                  fontWeight: "600",
                  p: 1,
                  mr: "10px",
                }}
              >
                {`${percentage}%`}
              </Typography>
            </Box>
            <Box sx={{ mr: "10px", textAlign: "right" }}>
              <Typography
                sx={{
                  color: getColor.PrimaryWoodSmoke,
                  fontSize: 18,
                  fontFamily: fonts.manrope,
                  fontWeight: "700",
                }}
              >
                {formatToIndianCurrency(lifeCoverage)}
              </Typography>
              <Typography
                sx={{
                  color: getColor.lavendershade,
                  fontSize: 12,
                  fontFamily: fonts.manrope,
                  fontWeight: "700",
                }}
              >
                {String.Dashboard.mainDashboard.LifeCoverage}
              </Typography>
            </Box>
          </Box>
        </CardContent>
        <CardContent
          sx={{
            display: "flex",

            justifyContent: "space-between",
            background: getColor.NeutralLightN60,
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralMIdDark400,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.mainDashboard.InsuranceTermlife}
          </Typography>

          <Typography
            sx={{
              color: getColor.PrimaryWoodSmoke,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {formatToIndianCurrency(termLifeInsurance)}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EstimatorCard;
